import { useState, useEffect, useRef } from 'react'
import { Api, Endpoint } from '../../api'
import SelectList from '../../components/SelectList'
import helpers from '../../helpers/general'
import CustomLineChart from '../../components/charts/CustomLineChart'
import CustomBarChart from '../../components/charts/CustomBarChart'
import styles from '../../components/Table/Table.module.scss'
import { Table as BootstrapTable } from 'react-bootstrap'
import LoadingSpinner from '../../components/LoadingSpinner'
import CustomPieChart from '../../components/charts/CustomPieChart'

const timeOptions = [
	{ value: '7', label: 'Last 7 days' },
	{ value: '30', label: 'Last 30 days' },
	{ value: '90', label: 'Last 90 days' },
	{ ...helpers.generateTimeOptions.thisWeek() },
	{ ...helpers.generateTimeOptions.thisMonth() },
	{ ...helpers.generateTimeOptions.thisQuarter() },
	{ ...helpers.generateTimeOptions.thisYear() },
]

function InteractionsDashboard() {
	const [data, setData] = useState()
	// const [activeUsers, setActiveUsers] = useState();
	const [time, setTime] = useState({ value: '7', label: 'Last 7 days' })
	const [titles, setTitles] = useState(null)
	const wrapper = useRef(null)
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		setTitles({
			activeUsers: `Number of Menu Viewers + Views (${time?.value} Day${time?.value !== 1 ? 's' : ''})`,
			bounceRate: `% of customers who viewed only one page (${time?.value} Day${time?.value !== 1 ? 's' : ''})`,
			screenPageViewsPerUser: `Number of Menu Items Viewed per Customer (${time?.value} Day${
				time?.value !== 1 ? 's' : ''
			})`,
			// averageSessionDuration: `Average user/customer time spent (seconds) (${
			userEngagementDuration: `Average user/customer time spent (minutes) (${time?.value} Day${
				time?.value !== 1 ? 's' : ''
			})`,
			sessionByHour: `Number of page views per hour (${time?.value} Day${time?.value !== 1 ? 's' : ''})`,
			sessions: `Number of page views in (${time?.value} Day${time?.value !== 1 ? 's' : ''})`,
			sessionsPerUser: 'Percentage of Repeat Viewers',
			sessionsBySource: `Where Viewers Saw Your Menu (${time?.value} Day${time?.value !== 1 ? 's' : ''})`,
		})
	}, [time])

	useEffect(() => {
		;(async () => {
			try {
				setLoading(true)
				const response = await Api.call(Endpoint.gapi.getData, {
					query: { time: time.value },
				})

				console.log({ response })

				if (response?.statusCode === 200 && response.confirmation !== 'Fail') {
					setData({
						...response?.message,
					})
				}
			} catch (error) {
				console.log({ error })
			} finally {
				setLoading(false)
			}
		})()
	}, [time])

	if (loading) {
		return <LoadingSpinner fullScreen />
	}

	return (
		<div ref={wrapper} style={{ marginBottom: 40 }}>
			<div style={{ maxWidth: 400, marginBottom: 40 }}>
				<SelectList
					placeholder="Select a time option..."
					value={time}
					onChange={setTime}
					options={timeOptions}
					isMulti={false}
				/>
			</div>
			<div
				style={{
					display: 'flex',
					gap: 10,
					flexWrap: 'wrap',
					width: '100%',
					marginBottom: 40,
				}}
			>
				{data?.activeUsers?.length > 0 && data.activeUsers[0]?.data?.length > 0 && (
					<section className="chart-wrapper">
						<h5>{titles?.activeUsers}</h5>
						<CustomLineChart data={data?.activeUsers} yScaleMin={0} />
					</section>
				)}

				{data?.bounceRate?.length > 0 && (
					<section className="chart-wrapper">
						<h5>{titles?.bounceRate}</h5>
						<CustomBarChart
							data={data?.bounceRate}
							valueFormat={(v) => `${(v * 100).toFixed(1)}%`}
							axisLeftFormat={(v) => `${Math.round(v * 100)}%`}
						/>
					</section>
				)}

				{/* {data?.userEngagementDuration?.[0]?.data?.length !== 0 && (
          <section className="chart-wrapper">
            <h5>{titles?.userEngagementDuration}</h5>
            <CustomLineChart data={data?.userEngagementDuration} />
          </section>
        )} */}

				{/* {data?.sessions?.[0]?.data?.length > 0 && (
          <section className="chart-wrapper">
            <h5>{titles?.sessions}</h5>
            <CustomLineChart data={data?.sessions} />
          </section>
        )} */}

				{data?.sessionsPerUser?.length > 0 && data.sessionsPerUser[0]?.data?.length > 0 && (
					<section className="chart-wrapper">
						<h5>{titles?.sessionsPerUser}</h5>
						<CustomLineChart
							data={data?.sessionsPerUser}
							yFormat={(v) => `${v}%`}
							axisLeftFormat={(v) => `${Math.round(v)}%`}
							yScaleMin={0}
						/>
					</section>
				)}

				{data?.screenPageViewsPerUser?.length > 0 && data.screenPageViewsPerUser[0]?.data?.length > 0 && (
					<section className="chart-wrapper">
						<h5>{titles?.screenPageViewsPerUser}</h5>
						<CustomLineChart data={data?.screenPageViewsPerUser} yScaleMin={0} />
					</section>
				)}

				{data?.sources?.length > 0 && (
					<section className="chart-wrapper">
						<h5>Where Viewers Saw Your Menu</h5>
						<CustomPieChart data={data?.sources} />
					</section>
				)}

				{data?.mostVisitedMenus?.length > 0 && (
					<section className="chart-wrapper">
						<h5>
							Most visited Menus ({time?.value} Day
							{time?.value !== 1 ? 's' : ''})
						</h5>
						<div className={styles.customTableWrapper}>
							<BootstrapTable className={styles.customTable}>
								<thead>
									<tr>
										<th>#</th>
										<th>Menu Title</th>
										<th style={{ textAlign: 'right' }}># Visits</th>
									</tr>
								</thead>
								<tbody>
									{data?.mostVisitedMenus?.map((menu, index) => {
										const regex = /platform\.foodi-menus\.com\/menu\/([a-f0-9]{24})/

										const match = menu?.path?.match(regex)
										if (match) {
											const path = match[1]
											return (
												<tr key={index}>
													<td>{index + 1}</td>
													<td>
														<a
															href={`https://${menu?.path}`}
															target="_blank"
															rel="noreferrer"
														>
															{menu?.title}
														</a>
													</td>
													<td
														style={{
															textAlign: 'right',
															fontWeight: 'bold',
															fontFamily: 'monospace',
														}}
													>
														{menu?.value}
													</td>
												</tr>
											)
										} else {
											return null
										}
									})}
								</tbody>
							</BootstrapTable>
						</div>
					</section>
				)}

				{data?.mostVisitedMenuItems?.length > 0 && (
					<section className="chart-wrapper">
						<h5>
							Most visited menu item ({time?.value} Day
							{time?.value !== 1 ? 's' : ''})
						</h5>

						<div className={styles.customTableWrapper}>
							<BootstrapTable className={styles.customTable}>
								<thead>
									<tr>
										<th>#</th>
										<th>Menu Title</th>
										<th>Item Name</th>
										<th style={{ textAlign: 'right' }}># Visits</th>
									</tr>
								</thead>
								<tbody>
									{data?.mostVisitedMenuItems?.map((dish, index) => {
										const regex = /dish\/([a-f0-9]{24})/

										const match = dish?.path?.match(regex)
										if (match) {
											return (
												<tr key={index}>
													<td>{index + 1}</td>
													<td>{dish?.title}</td>
													<td>
														<a
															href={`https://${dish?.path}`}
															target="_blank"
															rel="noreferrer"
														>
															{dish?.name}
														</a>
													</td>
													<td
														style={{
															textAlign: 'right',
															fontWeight: 'bold',
															fontFamily: 'monospace',
														}}
													>
														{dish?.value}
													</td>
												</tr>
											)
										} else {
											return null
										}
									})}
								</tbody>
							</BootstrapTable>
						</div>
					</section>
				)}
			</div>
		</div>
	)
}

export default InteractionsDashboard
